<template>
    <div class="p-2 text-2xl inline  cursor-pointer" @click="goShare()">
        <span class="icon-share"></span>
    </div>
</template>

<script>
export default {
    name: "BtnShare",
    methods: {
        goShare() {
            let self = this;

            //this.trackEvent("Menu:Share", {});
            this.trackEvent("cta_click:Share",  {});

            $eventbus.$emit('toggle:email');
            $eventbus.$emit('menu:hide');
            
        }
    }
}
</script>

<style scoped lang="scss">

</style>
